export default __webpack_public_path__ + "static/logo-white-39d511306d90d5650e6a4ee59d83fd3f.png";